import { FullApplicant } from "views/applications-id/components/ApplicantsTable/types";
import { AuditSummaryFlag } from "views/applications-id/components/ApplicantsTable/components/AuditSummaryFlag";

export const DataWithAuditFlag = ({
  hasData,
  dataValue,
  hasAuditFlagEnabled,
  auditSummaryFlags,
  fallbackValue = "-"
}: {
  hasData: boolean;
  dataValue: React.ReactNode;
  hasAuditFlagEnabled: boolean;
  auditSummaryFlags: FullApplicant["audit_summary_flags"];
  fallbackValue?: React.ReactNode;
}): JSX.Element => {
  if (hasData) return dataValue as JSX.Element;

  if (hasAuditFlagEnabled)
    return <AuditSummaryFlag audit_summary_flags={auditSummaryFlags} />;

  return <span>{fallbackValue}</span>;
};
